import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel, PageHeader } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import config       from "../config";
import { WhiteLabel }   from "../utils/WhiteLabelProps";
import { Colors }               from "../utils/Colors";
/*import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser
} from "amazon-cognito-identity-js"; // old aws login
*/
import { Auth } from "aws-amplify"; // new aws login
import "../css/Login.css";
import { invokeGetAppMainUserId, invokeSetTrackUserLogins } from "../utils/AwsInvoke";

export default class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: false,
          email: "",
          password: ""
        };
    }

    validateForm() {
        return this.state.email.length > 0 && this.state.password.length > 0;
    }

    handleChange = event => {
        this.setState({
          [event.target.id]: event.target.value
        });
    }

    handleSubmit = async event => {
        event.preventDefault();

        this.setState({ isLoading: true });

        try {
            const email = this.state.email;
            const password = this.state.password;

            // old: await this.login(this.state.email, this.state.password);
            //await Auth.signIn(email, password);
            var company_id = sessionStorage.getItem('company_id');

            await Auth.signIn(email, password)
                .then(user => {
                    //console.log("Signing in - Amplify user auth: " + user)
                    /*for(var key in user) {
                        console.log("key: " + key);
                        console.log("user: " + user[key]);
                    }*/

                    this.login(email, company_id);
                })
                .catch(err => {
                    this.setState({ isLoading: false, error: true });
                    console.log("Amplify Error: " + err)
                });



        } catch (e) {
            alert("Dev Error: " + e);
            this.setState({ isLoading: false, error: true });
        }
    }

    login = async (email, company_id) => {
        //console.log("login company_id: " + company_id);
        //// GET USER ID FROM USER EMAIL ////

        var result = await invokeGetAppMainUserId(email, company_id);
        console.log("++++++++++++++++++ LOGIN ++++++++++++++++");
        console.log("result.status: "+ result.status);
        if(result.status == true) {
            var global_user_id        = result.data[0].uid;
            var global_user_role_id   = result.data[0].role_id;
            var global_company_id     = result.data[0].company_id;
            var trainer_free_trial    = result.data[0].trainer_on_trial_period;
            var trainer_using_free_trial = false;

            if(trainer_free_trial != undefined && trainer_free_trial != null)
                trainer_using_free_trial = true;

            var result2 = await invokeSetTrackUserLogins(global_user_id)
            if(result2.status == true) {

                    this.props.setGlobalAdminUserEmail(email);
                    this.props.setGlobalAdminUserRoleId(global_user_role_id);
                    this.props.setGlobalAdminUserId(global_user_id);
                    this.props.setGlobalTrainerOnTrialPeriod(trainer_using_free_trial);
                    this.props.setGlobalExerciseVideoOptions();
                    this.props.userHasAuthenticated(true);

                    ////  Reset Trainer's company ids if using Freee Trial period  ////
                    if(trainer_using_free_trial)
                        this.props.setNewGlobalCompanyId(global_company_id);
            } else
                this.setState({ isLoading: false, error: true });
        } else
            this.setState({ isLoading: false, error: true });
    }

    /*login(email, password) {
          const userPool = new CognitoUserPool({
            UserPoolId: config.cognito.USER_POOL_ID,
            ClientId: config.cognito.APP_CLIENT_ID
          });
          const user = new CognitoUser({ Username: email, Pool: userPool });
          const authenticationData = { Username: email, Password: password };
          const authenticationDetails = new AuthenticationDetails(authenticationData);

          return new Promise((resolve, reject) =>
            user.authenticateUser(authenticationDetails, {
              onSuccess: result => resolve(),
              onFailure: err => reject(err)
            })
          );
    }*/

    render() {
        var error_text;
        if(this.state.error)
            error_text = "Your username or password was incorrect."

        var athlete_url    = sessionStorage.getItem('athlete_url');
        var athlete_link   = "";
        if(athlete_url != undefined)
            athlete_link = <span style={{fontSize:15, textAlign: "center", position: "relative", top: 20, left:50, color: "#666"}}>
                                Wrong page? Login as an <a href={"https://"+athlete_url} target="new"> athlete</a>.
                            </span>

        return (
          <div className="Login">
            <form onSubmit={this.handleSubmit}>
              <FormGroup controlId="email" bsSize="large" style={{border:"0px solid #000"}}>
                  <span style={{fontSize:34, textAlign:"center", position: "relative", left:60, bottom: 20}}>
                      <br/>
                      Trainer Login
                      <br/>
                  </span>
                  <ControlLabel className="loginTFLabels">Email</ControlLabel>
                  <FormControl
                      autoFocus
                      type="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                  />
              </FormGroup>
              <FormGroup controlId="password" bsSize="large">
                <ControlLabel className="loginTFLabels">Password</ControlLabel>
                <FormControl
                  value={this.state.password}
                  onChange={this.handleChange}
                  type="password"
                />
              </FormGroup>
              <span style={{color:"red", paddingTop:"10px", paddingLeft: "6px"}}> {error_text} </span>
              <span style={{display:"block", paddingTop:"5px"}}/>
              <LoaderButton
                    block
                    bsSize    = "large"
                    disabled  = {!this.validateForm()}
                    type      = "submit"
                    btncolor  = { Colors.ok_button_bg }
                    fontSize  = {20}
                    height    = {40}
                    isLoading = {this.state.isLoading}
                    text      = "Login"
                    loadingText = "Logging in…"
                />
                {athlete_link}
            </form>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/Login.js